module.exports = __webpack_public_path__ + "static/media/gm.ada07539f612d690eeb4c86647942f04.svg";